export const callChildAsFunction = child => typeof child === 'function' ? child() : child;